import { useQuery } from '@tanstack/react-query';
import apiClient from 'services/apiClient';
import moment from 'moment';

export const DAILY_BREAKDOWN_KEY_PREFIX = ['daily-breakdown'];
export const dailyBreakdownKey = (campaignID, year, month) =>
    [...DAILY_BREAKDOWN_KEY_PREFIX, campaignID, year, month];

const getStaleTime = (year, month) => {
    const now = moment();
    return year === now.year() && month === now.month() + 1
        ? 5 * 60 * 1000
        : Infinity;
};

export const useCampaignDailyBreakdown = (campaignID, year, month) =>
    useQuery(
        dailyBreakdownKey(campaignID, year, month),
        () => apiClient
            .get(`/Statistics/Campaign/${campaignID}/Daily`, { params: { CampaignID: campaignID, Year: year, Month: month } })
            .then(r => r.data.Stats),
        { staleTime: getStaleTime(year, month), enabled: campaignID > 0 }
    );

export const useAllCampaignsDailyBreakdown = (year, month) =>
    useQuery(
        dailyBreakdownKey(0, year, month),
        () => apiClient
            .get('/Statistics/Campaign/Daily', { params: { Year: year, Month: month } })
            .then(r => r.data.Data),
        { staleTime: getStaleTime(year, month) }
    );
